function truncate() {
    if (document.querySelector('.js-truncate')) {
        document.querySelectorAll('.js-truncate').forEach((container) => {
            const para = container.children[0];

            if (para) {
                const originalHTML = para.dataset.original || para.innerHTML;
                para.setAttribute('data-original', originalHTML);
                para.innerHTML = originalHTML;
                if (para.offsetHeight === 0 || container.clientHeight === 0) {
                    return;
                }
                while (para.offsetHeight > container.clientHeight) {
                    para.innerHTML = para.innerHTML.replace(/\W*\s(\S)*$/, '&hellip;');
                }
            }
        });
    }
}

window.addEventListener('resize', truncate);
truncate();

module.exports = truncate;
